import React from "react";

import { StyleSheet, Text, View, Button, TextInput, ImageBackground, Dimensions } from "react-native";
import imgSrc from './images/socialNetww.png';
const Tfinal = (props) => {


    return(            
			<View style={styles.container}>  
			<Text style={{margin: 8,
		fontWeight: "bold",
        fontSize: 24,}}>This is what your post will look like on social media</Text>
			 <View style={styles.container2}>                 
			<ImageBackground source={imgSrc}   style={{
				width: Dimensions.get('window').width/1.6,
				height: Dimensions.get('window').height/1.2,
				resizeMode: "stretch",
				alignSelf: "center",
				paddingTop:0,
				marginTop:0,
				//borderWidth: 1,
				//borderRadius: 1,
			}}> 
				  <View style={styles.textAreaContainer} >
                
					<TextInput
					style={styles.textArea}
				
					placeholder={props.navigation.state.params.detail}
					placeholderTextColor="black"
					numberOfLines={12}
					multiline={true}
                    editable = {false}
					value={props.navigation.state.params.detail}/>
                  
				</View>
				</ImageBackground>   
				</View>
        <View style={styles.container3}>	
			<Button 
			color='#341ada'
			title="Back"
			style={StyleSheet.buttonStyle}
			onPress={() => { props.navigation.navigate('Translate', {originalpost: props.navigation.state.params.detail,translated:props.navigation.state.params.translated, language: props.navigation.state.params.language,uid:props.navigation.state.params.uid}); }}> 
			</Button>		
			<Button 
            color='#341ada'
            title="Next"
            style={StyleSheet.buttonStyle}
            onPress={() => { props.navigation.navigate('Fasla2',{uid:props.navigation.state.params.uid,detail: null, language: props.navigation.state.params.language}); }}> 
			</Button>
        </View>  
	           
		</View>
     
    )
}
const styles = StyleSheet.create({
	container: {
		padding: 0,
		flex: 1,
		display: "flex",
		marginTop: 0,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
		backgroundColor:"#FFFFFF"
	},
	container2: {
		padding: 0,
		flex: 2,
		display: "flex",
		marginTop: 0,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
		backgroundColor:"#FFFFFF"
	},
	container3: {
		padding: 20,
		marginTop: 20,
		width: '20%',
		flexDirection: "row",
	   marginLeft:'40%',
		justifyContent: 'space-between', 
			textAlign: 'center',
			backgroundColor:"#FFFFFF"
	},
	buttonContainer:{
		width: '19%',
		alignSelf: 'center',
		marginVertical: 12,
        marginHorizontal: 30,
        flex:1,
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center'
	},

	text: {
		fontWeight: "bold",
		fontSize: 20
	},
	buttonStyle: {
		alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 12,
	paddingHorizontal: 32,
	borderRadius: 0,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
        flexDirection: "column",
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
      label: {

        margin: 8,
		fontWeight: "bold",
        fontSize: 13,
        color:'#808080',
        //paddingLeft:860,
      },
      textAreaContainer: {
		
		marginTop: Dimensions.get('window').height/1.71,
		marginRight:Dimensions.get('window').width/13,
		marginLeft: Dimensions.get('window').width/12,
		marginBottom: 10,

	  },
      textAreaContainer2: {
		
		paddingTop: 10,
		paddingRight:Dimensions.get('window').width/20,
		paddingLeft: Dimensions.get('window').width/20,
		paddingBottom: 10,

	  },
	  textArea: {
		height: Dimensions.get('window').height/13,
		fontSize: 13,
		//borderColor: '#000000',
		//borderWidth: 2,
		//backgroundColor:"grey",
		justifyContent: "flex-start"
	  }
})
export default Tfinal